import React from 'react';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ToastContainers = () => {
  return (
    <div>
      <ToastContainer position="top-right" />
    </div>
  );
}

export default ToastContainers;
